<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="data">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Type</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Value</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Minimum</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Maximum</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Current Value</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Status</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Approved By</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td class="font-weight-bold text-dark">{{ row.Type }}</td>
        <td class="text-dark">{{ row.Value }}</td>
        <td class="text-dark">{{ row.Minimum }}</td>
        <td class="text-dark">{{ row.Maximum }}</td>
        <td class="font-weight-bold text-info">{{ row.Col_Val }}</td>
        <td>
          <span class="badge px-2 py-1" [ngClass]="{
            'badge-success': row.Status == 'Approved',
            'badge-warning': row.Status == 'Pending',
            'badge-danger': row.Status == 'Rejected'
          }">{{ row.Status }}</span>
        </td>
        <td class="text-dark">{{ row.Approved_BY }}</td>
        <td class="text-muted small" style="white-space: normal !important; word-break: break-word !important; min-width: 160px;" [title]="row.DeviationRemark">{{ row.DeviationRemark || '-' }}</td>

      </tr>
    </tbody>
  </table>
</div>